var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 195,
    viewBox: "0 0 194 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1489_87524)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 95,
    r: 86,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7097 68.7604C80.0664 71.6254 75.3822 80.9549 78.2473 89.5982L80.0315 94.9809C80.9691 97.8093 79.9668 100.887 79.3236 103.797C78.9855 105.326 79.0429 106.964 79.5715 108.559C80.9376 112.68 85.0541 115.24 89.3239 114.453C93.564 113.671 98.8168 112.558 102.793 111.24C106.768 109.922 111.646 107.677 115.514 105.771C119.408 103.852 121.181 99.3404 119.815 95.2192C119.286 93.6237 118.353 92.2756 117.168 91.2508C114.913 89.301 112.268 87.4309 111.33 84.6012L109.547 79.2228C106.682 70.5795 97.353 65.8953 88.7097 68.7604Z",
    fill: "#CFE9C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5715 108.559L77.6432 109.198L79.5715 108.559ZM89.3239 114.453L89.6922 116.451L89.6922 116.451L89.3239 114.453ZM115.514 105.771L116.412 107.594L116.412 107.594L115.514 105.771ZM109.547 79.2228L111.476 78.5836L109.547 79.2228ZM117.168 91.2508L115.839 92.7875L117.168 91.2508ZM111.33 84.6012L109.402 85.2404L111.33 84.6012ZM80.1756 88.959C77.6635 81.3806 81.7705 73.2007 89.3489 70.6887L88.0705 66.832C78.3622 70.0502 73.1009 80.5291 76.319 90.2374L80.1756 88.959ZM81.9599 94.3417L80.1756 88.959L76.319 90.2374L78.1032 95.6201L81.9599 94.3417ZM81.4999 107.92C81.0896 106.682 81.046 105.417 81.3072 104.235L77.34 103.358C76.925 105.236 76.9961 107.246 77.6432 109.198L81.4999 107.92ZM88.9556 112.455C85.7295 113.05 82.5619 111.124 81.4999 107.92L77.6432 109.198C79.3134 114.237 84.3788 117.43 89.6922 116.451L88.9556 112.455ZM102.153 109.311C98.3174 110.583 93.1794 111.676 88.9556 112.455L89.6922 116.451C93.9487 115.666 99.3163 114.532 103.432 113.168L102.153 109.311ZM114.616 103.949C110.763 105.848 105.989 108.04 102.153 109.311L103.432 113.168C107.547 111.804 112.529 109.507 116.412 107.594L114.616 103.949ZM117.886 95.8584C118.948 99.0623 117.559 102.499 114.616 103.949L116.412 107.594C121.258 105.205 123.413 99.6185 121.743 94.58L117.886 95.8584ZM115.839 92.7875C116.755 93.5794 117.476 94.6202 117.886 95.8584L121.743 94.58C121.096 92.6272 119.951 90.9718 118.496 89.714L115.839 92.7875ZM107.619 79.862L109.402 85.2404L113.259 83.962L111.476 78.5836L107.619 79.862ZM89.3489 70.6887C96.9272 68.1766 105.107 72.2836 107.619 79.862L111.476 78.5836C108.258 68.8753 97.7788 63.6139 88.0705 66.832L89.3489 70.6887ZM118.496 89.714C117.26 88.6454 116.185 87.8173 115.195 86.8227C114.247 85.8704 113.589 84.9585 113.259 83.962L109.402 85.2404C110.01 87.0736 111.143 88.5116 112.315 89.6892C113.446 90.8246 114.82 91.9065 115.839 92.7875L118.496 89.714ZM78.1032 95.6201C78.4334 96.6161 78.4507 97.7399 78.2596 99.0693C78.0599 100.458 77.6926 101.764 77.34 103.358L81.3072 104.235C81.5979 102.92 82.0533 101.233 82.2812 99.6475C82.5176 98.0035 82.5673 96.1741 81.9599 94.3417L78.1032 95.6201Z",
    fill: "#CFE9C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.352 115.332C109.749 117.538 108.089 119.41 105.756 120.183C103.423 120.956 100.974 120.446 99.1729 119.038",
    stroke: "currentColor",
    strokeWidth: 4.06299,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1489_87524",
    x: 0.165354,
    y: 0.874015,
    width: 193.669,
    height: 193.669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.70866
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898039 0 0 0 0 0.898039 0 0 0 0 0.898039 0 0 0 0.47 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1489_87524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1489_87524",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotification);
export default __webpack_public_path__ + "static/media/empty-notification.13d833778a44a3fc1826303ebaff470c.svg";
export { ForwardRef as ReactComponent };